/* site/edit/SiteEditLayer.jsx — the seam between the public site and the visual editor.
 *
 * Deliberately tiny: SiteLayout imports THIS statically, and everything expensive (the overlay and
 * the full content index, which pulls the 228 KB piece catalogue) is behind a dynamic import that
 * only runs for a signed-in superadmin who opened the page with ?edit=1. An ordinary visitor
 * downloads none of it.
 */
import React, { Suspense, useEffect, useState } from "react";
import { useEditSession, mergeDeep } from "./EditContext";

const EditOverlay = React.lazy(() => import("./EditOverlay"));

export default function SiteEditLayer({ rootRef }) {
  const session = useEditSession();
  const active = !!(session && session.active);
  const [defaults, setDefaults] = useState(null);

  /* the built-in content of every page — the base the editor resolves paths against */
  useEffect(() => {
    if (!active || defaults) return undefined;
    let alive = true;
    import("../content").then((m) => { if (alive) setDefaults(m.default || {}); }).catch(() => {});
    return () => { alive = false; };
  }, [active, defaults]);

  /* leave room for the bottom toolbar */
  useEffect(() => {
    if (!active) return undefined;
    document.body.setAttribute("data-lhc-editing", "1");
    return () => document.body.removeAttribute("data-lhc-editing");
  }, [active]);

  if (!active || !defaults) return null;
  const content = mergeDeep(mergeDeep(defaults, session.saved || {}), session.draft || {});
  return (
    <Suspense fallback={null}>
      <EditOverlay rootRef={rootRef} content={content} />
    </Suspense>
  );
}
